var exports = {
  "U": "xdde3148b--150890--content-container",
};

module.exports = exports;
